/**
 * @generated SignedSource<<61ed5af44d6ff650f3ceb55ec9530e67>>
 * @relayHash dc0ee3a00570c8a4476b76e947391702
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e1d1eb200ab0fee3f493fb7fc558a2c0a806551d56073089018f3e539686bf5e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type selectIssueTransitionIssueAdjustmentsQuery$variables = {
  ari: string;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
};
export type selectIssueTransitionIssueAdjustmentsQuery$data = {
  readonly node: {
    readonly fieldOptions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly label: string | null | undefined;
          readonly value: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id?: string;
  } | null | undefined;
};
export type selectIssueTransitionIssueAdjustmentsQuery = {
  response: selectIssueTransitionIssueAdjustmentsQuery$data;
  variables: selectIssueTransitionIssueAdjustmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterById"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ari"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "filterById",
    "variableName": "filterById"
  },
  {
    "kind": "Literal",
    "name": "searchBy",
    "value": ""
  }
],
v4 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "value"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "selectIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraSingleSelectField"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "selectIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraSingleSelectField"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e1d1eb200ab0fee3f493fb7fc558a2c0a806551d56073089018f3e539686bf5e",
    "metadata": {},
    "name": "selectIssueTransitionIssueAdjustmentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d491ce6e025f96ae1790f91d97c73cf5";

export default node;
